/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/movie/shared/desktop/rottenTomatoes.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'movie/shared/desktop/rottenTomatoes', exports: {} };
const exports = module.exports;



import { Fandango as Fandango_movieDetails_context } from '@take-2/fd-modules/splits/require-core';

const { movieDetails, context: { req: { route } } } = Fandango_movieDetails_context;


import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import { fd_url_manager as links } from '@take-2/fd-modules/splits/require-core';



import { swig as swig } from '@take-2/fd-modules/splits/require-core';



import { Fandango_xhr as xhr } from '@take-2/fd-modules/splits/require-core';



import { Fandango_eventQueue as eventQueue } from '@take-2/fd-modules/splits/require-global';



const { EventNames } = eventQueue


const Selectors = {
    CONTAINER: '.js-rotten-tomatoes'
}


const ICON_PREFIX = 'icon-rottom-flat-'


const RouteNames = Object.freeze({
    MOVIE_REVIEWS: 'reviews'
})


const ReviewsTypes = {
    CRITIC: 'critic',
    MOVIE: 'movie',
}
function onDone(result) {
    if (!result || !result.data) {
        return;
    }
    const data = result.data;
    const { id, sluggedTitle } = movieDetails;
    const viewModel = {
        criticsURL: links.reviews({ title: sluggedTitle, id, reviewsType: ReviewsTypes.CRITIC }),
        criticsScore: data.criticsScore,
        iconClassCritics: ICON_PREFIX + data.criticsRating,
        audienceURL: links.reviews({ title: sluggedTitle, id, reviewsType: ReviewsTypes.MOVIE }),
        audienceScore: data.audienceScore,
        iconClassAudience: ICON_PREFIX + data.audienceRating
    };
    const markup = swig.render('_rottenTomatoesRating', viewModel);
    document.querySelector(Selectors.CONTAINER).innerHTML = markup;
}
function onFail(err) {
    debugLog.warn(module.name, 'Fan Reviews API Fail', err);
}
function init() {
    const container = document.querySelector(Selectors.CONTAINER);
    if (!container) {
        return;
    }
    const movie = movieDetails;
    if (!movie || !movie.id) {
        return;
    }
    if (route !== RouteNames.MOVIE_REVIEWS) {
        xhr.ajax({
            method: 'GET',
            url: links.napiFanAndCriticReviews({
                id: movie.id,
                pageSize: 1
            }),
        })
            .done(onDone)
            .fail(onFail);
    }
    else {
        eventQueue.on(EventNames.MOP_FAN_CRITIC_REVIEWS_API, onDone);
    }
}
export default {
    init,
};
